module.exports = "/assets/images/plus-in-circle_bb1c10.svg";